/*
* <license header>
*/

import React from 'react'
import { Heading, Text, View } from '@adobe/react-spectrum'
import { useNavigate } from 'react-router-dom'
import Star from '@spectrum-icons/workflow/Star'
import StarOutline from '@spectrum-icons/workflow/StarOutline'

export const TypeCard = ({ slug, title, badge, description, package: pkg, version, isFavorite = false, onToggleFavorite }) => {
  const navigate = useNavigate()
  const wizardPath = slug ? `/wizard?type=${slug}` : '/wizard'
  const handleClick = () => navigate(wizardPath)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      navigate(wizardPath)
    }
  }
  const handleStarClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onToggleFavorite?.(slug)
  }
  const handleStarKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation()
      e.preventDefault()
      onToggleFavorite?.(slug)
    }
  }
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer', height: '100%', minWidth: 0, position: 'relative' }}
    >
    <View
      UNSAFE_style={{
        position: 'relative',
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1.25rem',
        backgroundColor: 'var(--white)',
        cursor: 'pointer',
        minHeight: '10rem',
        height: '100%'
      }}
    >
      {onToggleFavorite && (
        <button
          type="button"
          onClick={handleStarClick}
          onKeyDown={handleStarKeyDown}
          aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
          style={{
            position: 'absolute',
            top: '0.75rem',
            right: '0.75rem',
            padding: '0.25rem',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            color: isFavorite ? '#f4b400' : '#9e9e9e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {isFavorite ? (
            <Star size="S" UNSAFE_style={{ width: 18, height: 18 }} />
          ) : (
            <StarOutline size="S" UNSAFE_style={{ width: 18, height: 18 }} />
          )}
        </button>
      )}
      <View
        UNSAFE_style={{
          display: 'inline-block',
          padding: '0.25rem 0.5rem',
          borderRadius: '4px',
          backgroundColor: 'var(--card-accent)',
          color: 'white',
          fontSize: '0.75rem',
          fontWeight: 600,
          marginBottom: '0.75rem'
        }}
      >
        {badge}
      </View>
      <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.25rem', fontSize: '1.125rem' }}>
        {title}
      </Heading>
      {pkg && (
        <Text UNSAFE_style={{ color: 'var(--gray-500)', fontSize: '0.75rem', fontFamily: 'monospace', marginBottom: '0.25rem' }}>
          {pkg}{version ? `@${version}` : ''}
        </Text>
      )}
      <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', lineHeight: 1.5, marginTop: '0.5rem', display: 'block' }}>
        {description}
      </Text>
    </View>
    </div>
  )
}
